import useSWR from 'swr';
import { TeamListItemFragment } from '@amf/shared/types/graphql';

const getKey = (leagueId?: string, clubId?: string) => {
  if (!leagueId && !clubId) return null;
  const params = new URLSearchParams();
  if (leagueId !== undefined) params.append('leagueId', leagueId);
  if (clubId !== undefined) params.append('clubId', clubId);
  return `/api/team/list?${params}`;
};

function useTeamList(leagueId?: string, clubId?: string) {
  const { data, error } = useSWR<TeamListItemFragment[]>(getKey(leagueId, clubId));
  return {
    error,
    teams: data ?? [],
    loading: !data && !error,
  };
}

export default useTeamList;
